import Layout from "../components/layout/Layout"
import NewsDetailsSection from "../components/sections/NewsDetailsSection"
export default function BlogDetails1() {
	return (
		<>
			<Layout headerStyle={1} footerStyle={1} breadcrumbTitle="Blog 1 Details">
				<NewsDetailsSection />
			</Layout>
		</>
	)
}